export default __webpack_public_path__ + "static/media/triporate.74cf78cc.less";